export const features = {
  intake : "Intake"
};
